<script>
import Dropzone from 'vue2-dropzone'
import { FormGenerator } from '@/components/common/form-generator'

export default {
  data() {
    return {
      name: '',
      dropzoneOptions: {
        maxFiles: 1,
        url:
          '/api/v1/hives/' +
          this.$router.currentRoute.params.hexId +
          '/register',
        dictDefaultMessage: this.defaultMessage(),
        autoProcessQueue: false,
        previewTemplate: this.dropzoneTemplate(),
        sending: this.dropzoneSending,
        acceptedFiles: '.jar, .dll'
      }
    }
  },

  methods: {
    dropzoneError: function(errorData) {
      this.$refs.dropzone.removeAllFiles(true)
    },
    defaultMessage: function() {
      return `<div>
                                        <div>Drag and Drop the Bot file or click to upload</div>
                                        <div class="upload"><i class="v-icon material-icons">cloud_upload</i></div>
                                      </div>`
    },
    dropzoneTemplate: function() {
      return `<div class="dz-preview dz-file-preview">
                                        <div class="dz-details">
                                          <div class="dz-filename">Now uploading<br><br><div data-dz-name></div></div>
                                          <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                                        </div>
                                      </div>`
    },

    dropzoneSending(file, xhr, formdata) {
      formdata.append('className', name)
    },

    registerBot: function() {
      this.$refs.dropzone.processQueue()
    }

    // backtohive() {
    //     this.$router.replace({ name: "hive-bot-list" });
    // }
  },

  components: {
    FormGenerator,
    dropzone: Dropzone
  }
}
</script>

<template>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-toolbar dense class="elevation-0">
          <v-toolbar-title class="body-2 beez-bold "
            >REGISTER NEW BOT
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Actions icon list goes here -->
          <v-tooltip bottom>
            <v-btn slot="activator" icon flat @click="backtohive">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Close</span>
          </v-tooltip>
        </v-toolbar>
        <v-layout row wrap pa-4>
          <v-flex xs12 sm3>
            <v-subheader v-text="'Class Name'" />
          </v-flex>
          <v-flex xs12 sm9>
            <v-text-field
              label="Class Name"
              color="secondary"
              hint="Enter a name for the main Class"
              persistent-hint
              v-model="name"
            >
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap pa-4>
          <v-flex xs12 sm3>
            <v-subheader v-text="'Upload File'" />
          </v-flex>
          <v-flex xs12 sm9>
            <dropzone
              style="height: 100%"
              id="workflowDropzone"
              :options="dropzoneOptions"
              ref="dropzone"
              @vdropzone-error="dropzoneError($event)"
            >
            </dropzone>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <v-btn primary @click="registerBot()">Register Hive</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>
